import Output       from '../Output';
import RawLine      from './Line/RawLine';

export default class RawOutput extends Output {

    static line = RawLine;

    output() {
        let output = '';

        for(let i = 0; i < this.subject.length; i++) {
            output += `<li>${this.subject[i].output()}</li>`;
        }

        return output;
    }
}